import { useContext, useState } from "react";
import UiContext from "../../../../store/ui-context";
import useAPIRequest from "../../../../custom_hooks/simple/useAPIRequest";

const defaultTake = 10;

export const useAPIGetKendaraanService = () => {
  const uiContext = useContext(UiContext);
  const { requestGet, loading } = useAPIRequest();

  const [filterValue, setFilterValue] = useState({
    nomor_polisi: "",
    kendaraan_jenis_id: null,
    kendaraan_jenis: null,
  });

  const [paging, setPaging] = useState({
    page: 1,
    take: defaultTake,
    total: 0,
    filter: "",
  });
  const [listData, setListData] = useState([]);

  //  API call section

  const fetchListData = async ({ page, take, filter }) => {
    if (
      !filterValue.kendaraan_jenis_id ||
      filterValue.kendaraan_jenis_id <= 0
    ) {
      uiContext.showErrorMsg("Error", "Pilih jenis kendaraan terlebih dahulu");
      return;
    }

    const newFilter = filter ?? getFilter(filterValue);

    return requestGet({
      fullUrl: `/api/masterdata/kendaraan/data`,
      params: {
        page: page,
        take: take,
        filter: newFilter,
        order: "nomor_polisi",
        order_method: "ASC",
        with_services: 1,
      },
      onSuccess: ({ pagination, message, data }) => {
        setPaging({
          ...paging,
          total: pagination["total"],
          page: pagination["page"],
          take: pagination["take"],
          filter: newFilter,
        });
        const newData = data.map((el, index) => {
          return {
            ...el,
            no: (page - 1) * take + index + 1,
          };
        });
        setListData(newData);
      },
      onError: ({ message, data }) => uiContext.showErrorMsg("Error", message),
    });
  };

  // other function section

  const getFilter = (_filterValue) => {
    const filterArr = [];

    const newFilterValue = _filterValue ?? filterValue;

    if (newFilterValue.nomor_polisi) {
      filterArr.push(`nomor_polisi:contains:${newFilterValue.nomor_polisi}`);
    }

    if (
      newFilterValue.kendaraan_jenis_id &&
      newFilterValue.kendaraan_jenis_id > 0
    ) {
      filterArr.push(
        `kendaraan_jenis_id:=:${newFilterValue.kendaraan_jenis_id}`
      );
    }

    return filterArr.join(";");
  };

  // handle ui event section

  const handleOnClickRefresh = async () => {
    fetchListData({ page: 1, take: defaultTake });
  };

  const handleOnPage = (e) => {
    const newPage = e.first / paging.take + 1;
    const newTake = e.rows;

    setPaging({ ...paging, take: newTake, page: newPage });
    fetchListData({ page: newPage, take: newTake, filter: paging.filter });
  };

  const handleOnUpdateViewRow = (row) => {
    let foundInList = false;
    let newListData = listData.map((el) => {
      if (el.id === row.id) {
        foundInList = true;
        return row;
      }
      return el;
    });

    if (!foundInList) {
      if (newListData.length > 0) {
        newListData.unshift(row);
      } else {
        newListData.push(row);
      }
    }

    // reorder no
    newListData = newListData.map((el, index) => {
      return {
        ...el,
        no: (paging.page - 1) * paging.take + index + 1,
      };
    });

    setListData(newListData);
  };

  const handleOnDeleteViewRow = (row) => {
    let newListData = [...listData];

    const index = newListData.findIndex((el) => el.id === row.id);
    if (index > -1) {
      newListData.splice(index, 1);
    }

    // reorder no
    newListData = newListData.map((el, index) => {
      return {
        ...el,
        no: (paging.page - 1) * paging.take + index + 1,
      };
    });

    setListData(newListData);
  };

  return {
    loading,
    listData,
    fetchListData,
    filterValue,
    setFilterValue,
    handleOnClickRefresh,
    handleOnPage,
    paging,
    handleOnUpdateViewRow,
    handleOnDeleteViewRow,
  };
};
